import { useEffect, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import type { ActivityForm } from '../typings'

export function useDueDateManagement() {
  const [{ value }] = useField('dueTime')
  const {
    setFieldTouched,
    values: { dueDate },
    setFieldValue,
    setErrors,
    errors,
  } = useFormikContext<ActivityForm>()
  useEffect(() => {
    if (!!value) {
      setFieldTouched('dueDate', true)
    }

    if (!dueDate) {
      setFieldValue('dueTime', null)
    }
  }, [value, setFieldTouched, dueDate, setFieldValue])

  useEffect(() => {
    if (!dueDate && !!errors.dueTime) {
      const updatedErrors = { ...errors }
      delete updatedErrors.dueTime
      setErrors({ ...updatedErrors })
    }
  }, [dueDate, errors, setErrors])

  return {
    timeDisabled: useMemo(() => !dueDate, [dueDate]),
  }
}
